import React from 'react';
import { useNavigate } from 'react-router-dom';
import Block from '../../../components/block';
import { Button } from 'antd';

const ErrorPage: React.FC = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate back to the previous page
  };

  const handleGoHome = () => {
    navigate('/home'); // Navigate to the home page
  };

  return (
    <Block>
      <h1 className='text-red-600 text-4xl text-center'>Oops! Something went wrong.</h1>
      <p className='text-gray-500 text-lg text-center'>We couldn't find the page you were looking for.</p>
      <div className="flex gap-2 justify-center">
        <Button onClick={handleGoBack} className="shadow">
          Go Back
        </Button>
        <Button type='primary' onClick={handleGoHome} className="shadow-m">
          Go to Home
        </Button>
      </div>
    </Block>
  );
};

export default ErrorPage;
